"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomText = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var CustomText = function CustomText() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    d: "M13.583 23.2c0 .442-.354.8-.791.8h-1.584a.796.796 0 0 1-.791-.8v-20H3.292a.796.796 0 0 1-.792-.8V.8c0-.442.354-.8.792-.8h17.416c.438 0 .792.358.792.8v1.6c0 .442-.354.8-.792.8h-7.125v20Z",
    fill: "currentColor"
  }));
};

exports.CustomText = CustomText;